import styled from "styled-components";

const RootContainer = styled.div`
  overflow: overlay;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow: auto;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 3;
`;

const ContentContainer = styled.div`
  padding-bottom: 100px;
  margin: 0;
  margin-top: 60px;
`;

const ClearButton = styled.button`
  border: 2px solid black;
  background: white;
  outline: none;
  color: black;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
`;

const GoBackButton = styled.div`
  :hover {
    cursor: pointer;
  }
`;

const AddToCardButton = styled.button`
  border: 2px solid black;
  background: black;
  color: white;
  outline: none;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
`;

const modules = {
  RootContainer,
  HeaderContainer,
  ContentContainer,
  ClearButton,
  AddToCardButton,
  GoBackButton,
  DescriptionContainer,
};

export default modules;
